import { FC, ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import { KeyboardBackspace } from "@mui/icons-material";

import { success_icon } from "@/constants";
import { tokens } from "@/tokens";

const ResetPasswordSuccess: FC = (): ReactElement => {
  const navigate = useNavigate();

  return (
    <Stack
      direction={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      height={"100%"}
    >
      <Box sx={{ width: { xs: "95%", sm: "70%" }, p: { xs: 2, md: 0 } }}>
        <Stack
          spacing={1}
          direction={"column"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <img src={success_icon} alt="success icon" width={74} />
          <Box textAlign={"center"}>
            <Typography fontSize={{ md: "32px", xs: "22px" }} fontWeight={tokens.fontWeight.bold}>
              Reset Password successfully
            </Typography>
            <Typography fontSize={tokens.fontSize.lg} sx={{ color: tokens.text.secondary }}>
              Your password has been reset. Go back to login page and login with
              your new password.
            </Typography>
          </Box>
        </Stack>
        <Box sx={{ my: 2 }}></Box>
        <Button
          variant="outlined"
          fullWidth
          sx={{
            mt: 2,
            py: 1.5,
            fontSize: tokens.fontSize.xl,
            fontWeight: tokens.fontWeight.semibold,
            color: tokens.text.primary,
            border: "1px solid #D4D6D9",
          }}
          color="secondary"
          onClick={() => navigate("/login")}
          startIcon={<KeyboardBackspace />}
        >
          Back to Login
        </Button>
      </Box>
    </Stack>
  );
};

export default ResetPasswordSuccess;
